import { API_VERSION_ESYMANDANT, fetchHandler, HTTP_METHOD, limiter } from 'application/api/request_builders'
import { fetchRequestBuilder } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const updatePassword = (passwordHashKey, password) => {

    const request = fetchRequestBuilder(API_VERSION_ESYMANDANT + '/user/password/' + passwordHashKey, HTTP_METHOD.PUT, { password })

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}